import React, { useState } from "react";
import { BiSolidPhoneIncoming } from "react-icons/bi";
import { DetailsTab } from "./Details/DetailsTab";
import { ImageTab } from "./ImagesFiles/ImageTab";
import { Modal } from "./Modal";
import mobile from "./Details/icons/Mobile-phone.png";
import dashboard from "./Details/icons/Dashboard.png";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import themes from "./Details/icons/Template.png";
import font from "./Details/icons/Typeface.png";
import gift from "./Details/icons/Gift.png";
const options = [
  {
    value: "UI Kits",
    label: (
      <div className="flex items-center">
        <img
          src={mobile}
          className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
          alt="mobile"
        />{" "}
        UI Kits
      </div>
    ),
  },
  {
    value: "Dashbords / Admin Panels",
    label: (
      <div className="flex items-center">
        <img
          src={dashboard}
          className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
          alt="mobile"
        />{" "}
        Dashbords / Admin Panels
      </div>
    ),
  },
  {
    value: "Themes & Templates",
    label: (
      <div className="flex items-center">
        <img
          src={themes}
          className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
          alt="mobile"
        />{" "}
        Themes & Templates
      </div>
    ),
  },
  {
    value: "Fonts",
    label: (
      <div className="flex items-center">
        <img
          src={font}
          className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
          alt="mobile"
        />{" "}
        Fonts
      </div>
    ),
  },
  {
    value: "Freebies",
    label: (
      <div className="flex items-center">
        <img
          src={gift}
          className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
          alt="mobile"
        />{" "}
        Freebies
      </div>
    ),
  },
  // Add more options here if needed
];

export const AddingProducts = () => {
  const [currentTab, setCurrentTab] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showFontsKeyAspects, setShowFontsKeyAspects] = useState(false);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    if (option.value === "Fonts") {
      setShowFontsKeyAspects(true);
    } else {
      setShowFontsKeyAspects(false);
    }
    setIsDropdownOpen(false);
  };

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  const handleConfirm = () => {
    // Handle confirm action here
    setIsModalOpen(false);
  };

  const [data, setData] = useState({
    productInfo: {},
    keyAspects: {},
    keyAspectsFonts: {},
    productDescriptions: {},
    featuresBenefits: {},
    licensePrices: {},
    toolsUsed: {},
    productCardThumbnail: {},
    carouselImages: {},
    userFlows: [],
    productFiles: [],
    offeringFreeVersion: [],
  });

  const handleSubmit = () => {
    const dataArray = [
      { productInfo: data.productInfo },
      { keyAspects: data.keyAspects },
      { keyAspectsFonts: data.keyAspectsFonts },
      { productDescriptions: data.productDescriptions },
      { featuresBenefits: data.featuresBenefits },
      { licensePrices: data.licensePrices },
      { toolsUsed: data.toolsUsed },
      { productCardThumbnail: data.productCardThumbnail },
      { carouselImages: data.carouselImages },
      { userFlows: data.userFlows },
      { productFiles: data.productFiles },
      { offeringFreeVersion: data.offeringFreeVersion },
    ];

    console.log({ selected: selectedOption, data: dataArray });
  };

  return (
    <div className="lg:px-6">
      <div className="flex justify-between items-center w-full">
        <div className="flex pt-4 items-center justify-between space-x-3 w-full md:w-fit">
          <h1 className="text-[28px] md:text-[32px]">Adding Product</h1>
          <div
            className={` relative current-select flex items-center space-x-2 px-4 py-2 rounded-xl text-xl cursor-pointer ${
              isDropdownOpen
                ? "border border-gray-500 dark:border-[#5B5B5B]"
                : "border border-gray-300 dark:border-white "
            }`}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <div className="truncate max-w-[100px]">{selectedOption.label}</div>
            <div>
              {isDropdownOpen ? (
                <FaChevronUp className="text-lg" />
              ) : (
                <FaChevronDown className="text-lg" />
              )}
            </div>
            {isDropdownOpen && (
              <div className="bg-[#F0F0F0] dark:bg-[#1C1C1C] border-[1.5px] mt-2 dark:border-[#5B5B5B] w-[340px] absolute top-14 -left-[200px] md:-left-2 drop-select flex flex-col px-4 py-2 rounded-xl text-xl z-10">
                {options.map((option, index) => (
                  <div
                    key={option.value}
                    className={`py-4  cursor-pointer ${
                      selectedOption.value === option.value
                        ? "opacity-100 border-white"
                        : "opacity-60"
                    } ${
                      index !== options.length - 1
                        ? "border-b border-b-[#5B5B5B]"
                        : ""
                    }`}
                    onClick={() => handleOptionClick(option)}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="md:flex items-center space-x-2 hidden ">
          <div className="border px-2 py-1 rounded-md dark:border-[#5B5B5B] ">
            <button onClick={() => setIsModalOpen(true)}>X Cancel</button>
          </div>
          <div className="bg-white text-black px-2 py-1 rounded-md">
            <button>Save Draft</button>
          </div>
          <div
            onClick={handleSubmit}
            className="bg-[#CBF0D0] text-black px-2 py-1 rounded-md"
          >
            <button>Submit for Review</button>
          </div>
        </div>
      </div>
      <hr className=" w-full my-4 dark:border-[#2F2F2F] border-[1px]" />

      <div className="flex space-x-2 items-center">
        <button
          onClick={() => handleTab(1)}
          className={
            currentTab === 1
              ? "dark:border-[2px] bg-[#1C1C1C]  text-white dark:border-white dark:bg-transparent dark:text-white rounded-lg px-4 py-2"
              : " bg-[#F0F0F0] dark:bg-[#282828]   rounded-lg px-4 py-2"
          }
        >
          Details
        </button>
        <button
          onClick={() => handleTab(2)}
          className={
            currentTab === 2
              ? "dark:border-[2px] bg-[#1C1C1C]  text-white dark:border-white dark:bg-transparent dark:text-white rounded-lg px-4 py-2"
              : "bg-[#F0F0F0] dark:bg-[#282828]   rounded-lg px-4 py-2"
          }
        >
          Images & Files
        </button>
      </div>

      {currentTab === 1 ? (
        <DetailsTab
          showFontsKeyAspects={showFontsKeyAspects}
          data={data}
          setData={setData}
          handleSubmit={handleSubmit}
        />
      ) : (
        <ImageTab data={data} setData={setData} handleSubmit={handleSubmit} />
      )}

      <div className="md:hidden">
        <div
          onClick={handleSubmit}
          className="bg-[#CBF0D0] text-black px-2 text-center py-3 rounded-md"
        >
          <button>Submit for Review</button>
        </div>
        <div className="bg-[#1c1c1c] text-white dark:bg-white my-4 dark:text-black px-2 py-3 text-center rounded-md">
          <button>Save Draft</button>
        </div>
        <div className="border px-2 py-3 text-center rounded-md">
          <button onClick={() => setIsModalOpen(true)}>X Cancel</button>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
};
